import { useChatState } from '@core/chat';

import { ChatTabs } from '@core/chat/interfaces';

export const useRedirectToGlobalChat = () => {
  const { setOpen: setOpenChat, setActiveTab } = useChatState();

  const redirectToGlobalChat = () => {
    setActiveTab(ChatTabs.Global);
    setOpenChat(true);
  };

  return redirectToGlobalChat;
};
